import { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import {
  getAppointmentTypeIdParamFromUrl,
  getCoreAppointmentIdFromUrl,
  getSpecialtyParamFromUrl,
} from '../../lib/scheduling/helpers';
import { AcuityAppointmentTag } from '../../lib/scheduling/types';
import { trackAppointmentTagForCurrentSession } from '../../lib/storage';
import userClient from '../../lib/user/client';
import Authenticating from '../Common/Authenticating/Authenticating';

const SelfSignIn: FC = () => {
  const [fetching, setFetching] = useState<boolean>(true);

  const { token } = useParams<{ token: string }>();
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      throw new Error("Invalid token, unable to fetch member's profile");
    }

    (async () => {
      const profile = await userClient.getProfileWithToken(token);

      if (!profile) {
        return navigate(`/error`);
      }

      const redirect = queryParams.get('redirect');

      if (redirect) {
        return navigate(redirect);
      }

      const appointmentTypeId = getAppointmentTypeIdParamFromUrl();
      const specialty = getSpecialtyParamFromUrl();

      if (!specialty && !appointmentTypeId) {
        return navigate(`/`);
      }

      const existingCoreAppointmentId = getCoreAppointmentIdFromUrl();

      if (specialty) {
        trackAppointmentTagForCurrentSession(AcuityAppointmentTag.MemberAppSelfSchedule);

        navigate(`/scheduling?specialty=${specialty}`);
      } else {
        navigate(
          `/scheduling?appointmentTypeId=${appointmentTypeId}${
            existingCoreAppointmentId
              ? `&existingCoreAppointmentId=${existingCoreAppointmentId}`
              : ''
          }`
        );
      }

      setFetching(false);
    })();
  });

  return (
    <>
      <Helmet>
        <title>Enara: Book your next appointment</title>
      </Helmet>

      {fetching && <Authenticating />}
    </>
  );
};

export default SelfSignIn;
